import React from "react";
import classNames from "classnames";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import { MediaInfoBlock } from "../createEvents/MediaTab";
import GetUpdatedOnBy from "../GetUpdatedOnBy";
import { LogRenderContext } from "../LogRenderer";

export const MediaCreated = () => {
  const { log } = React.useContext(LogRenderContext);
  const { medias } = log.dataSnapshot;
  const mediasNew = log.changedFields?.medias || [];

  if (!medias || medias.length === 0) {
    return (
      <div className={styles.noDataContainer}>
        <div>No media found</div>
      </div>
    );
  }

  return (
    <div className={styles.tabContainer}>
      {medias.map((media) => {
        const mediaNew = mediasNew?.find((m) => m.id === media.id);

        return (
          <div key={media.id} className={styles.mediaContainer}>
            <div className={styles.badgeContainer}>
              <div className={styles.campaignName}>{media.name}</div>
              <div className={classNames(styles.badge, styles.badgeSuccess)}>Created</div>
            </div>
            <GetUpdatedOnBy
              updatedAt={mediasNew?.[0]?.updatedAt}
              updatedBy={mediasNew?.[0]?.updatedBy}
            />
            <MediaInfoBlock media={media} mediaNew={mediaNew} />
          </div>
        );
      })}
    </div>
  );
};
